import React from 'react';
import { X, Check, AlertTriangle, Info } from 'lucide-react';
import { useApp } from '../../context/AppContext';

export const ToastContainer: React.FC = () => {
  const { toasts, removeToast } = useApp();

  if (toasts.length === 0) return null;

  const icons = {
    success: <Check size={15} className="text-emerald-500" />,
    error: <AlertTriangle size={15} className="text-red-500" />,
    info: <Info size={15} className="text-blue-500" />,
  };

  const borders = {
    success: 'border-l-brand-400',
    error: 'border-l-red-500',
    info: 'border-l-blue-500',
  };

  return (
    <div className="fixed bottom-6 right-6 z-50 space-y-2 max-w-sm">
      {toasts.map(toast => (
        <div
          key={toast.id}
          className={`glass-card shadow-lg px-4 py-3 flex items-center gap-3 border-l-4 ${borders[toast.type]} animate-fade-in`}
        >
          {icons[toast.type]}
          <span className="text-sm text-surface-700 flex-1">{toast.message}</span>
          <button onClick={() => removeToast(toast.id)} className="text-surface-400 hover:text-surface-600">
            <X size={14} />
          </button>
        </div>
      ))}
    </div>
  );
};
